import { folderCss, folderIconCss, folderWrapperCss } from "./index.styles";

import { GroupLabel } from "~/client/components/GroupsLabel";
import type { FolderItem } from "~/client/components/search/hooks/useFolderSearchResult";
import { ListItem } from "~/client/components/search/SearchBoxDropdown/ListItem";
import { ListItemLink } from "~/client/components/search/SearchBoxDropdown/ListItemLink";
import { KibelaSymbol } from "~/client/components/shared/kibela_symbol";

interface Props {
  item: FolderItem;
  isSelected: boolean;
}
export const Folder: React.FC<Props> = ({ item, isSelected }) => {
  return (
    <ListItem isSelected={isSelected}>
      <div css={folderWrapperCss}>
        <div css={folderCss}>
          <span css={folderIconCss}>
            <KibelaSymbol id="folder" />
          </span>
          <ListItemLink to={item.fixedPath}>
            <div dangerouslySetInnerHTML={{ __html: item.name }}></div>
          </ListItemLink>
        </div>
        <GroupLabel group={item.group} />
      </div>
    </ListItem>
  );
};
